import {
    Container,
    Sprite,
    Texture,
    filters,
} from 'pixi.js';
import { Grid, SimplePoint } from './Grid';
import { LoadContext, Tween } from '../../utils';
import { GAMEPLAY } from '../../constants';

enum Type
{
    Distractor,
    Part,
    Battery
}

enum State
{
    Hidden,
    Located,
    Found
}

const FOUND_FILTER = new filters.ColorMatrixFilter();
FOUND_FILTER.desaturate();
FOUND_FILTER.brightness(0.2, true);

export class Discoverable extends Container
{
    public static State = State;
    public static Type = Type;

    private discovered: Sprite;
    private unknown: Sprite;
    public type: Type;
    public name: string;
    public foundVO: string;
    private _state: State;
    public coord: SimplePoint;

    public static preload()
    {
        const loader = LoadContext.current;
        loader.add('GameAtlas', './assets/game/GameAtlas{size}.json');
    }

    constructor(grid: Grid, type: Type, name: string, atlasName?:string)
    {
        super();
        this.type = type;
        this.name = name;
        this.coord = {x: 0, y: 0};

        const loader = LoadContext.current;

        const texture:Texture = loader.getTexture(name, atlasName);
        this.discovered = new Sprite(texture);
        this.discovered.anchor.set(0.5);
        this.discovered.scale.set(grid.squareSize / Math.max(this.discovered.width, this.discovered.height));
        this.addChild(this.discovered);

        this.unknown = new Sprite(loader.getTexture('star', 'GameAtlas'));
        this.unknown.anchor.set(0.5);
        this.unknown.scale.set(grid.squareSize / 188);
        this.addChild(this.unknown);

        this.state = State.Hidden;
    }

    public get texture() { return this.discovered.texture; }

    public get state() { return this._state; }
    public set state(state)
    {
        this._state = state;
        this.discovered.filters = null;
        if (state === State.Hidden)
        {
            this.discovered.visible = false;
            this.unknown.visible = false;
        }
        else if (state === State.Located)
        {
            this.discovered.visible = false;
            this.unknown.visible = true;
            if (GAMEPLAY.HIDE_LOCATED)
            {
                this.unknown.alpha = 1;
                Tween.get(this.unknown).wait(GAMEPLAY.LOCATED_HIDE_TIME_MS).to({alpha: 0}, 500, 'quadInOut');
            }
        }
        else if (state === State.Found)
        {
            this.unknown.visible = false;
            if (GAMEPLAY.HIDE_FOUND)
            {
                this.discovered.visible = false;
            }
            else
            {
                this.discovered.visible = true;
                this.discovered.filters = [FOUND_FILTER];
            }
        }
    }

    public destroy()
    {
        Tween.removeTweens(this.unknown);
        super.destroy({children: true});
    }
}